
export enum InterestRateModifier {
    Multiply = 1,
    Add = 2,
    None = 3,
}